import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';

interface TagDeleteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  tagName: string;
}

const TagDeleteDialog: React.FC<TagDeleteDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  tagName,
}) => {
  return (
    <Dialog modalType='alert' open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
              />
            }
          >
            Radera etikett?
          </DialogTitle>
          <DialogContent>
            <p className="text-sm">
              Vill du radera etiketten "{tagName}"?
            </p>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onClose}>
              Avbryt
            </Button>
            <Button appearance="primary" onClick={onConfirm}>
              Radera
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default TagDeleteDialog;
